import { BytesPerKb, ISelectList } from '../interfaces';

export const useBytesPerKbSelectOptions = (): ISelectList =>
    Object.values(BytesPerKb).map((value) => ({
        id: value,
        name: value,
    }));
